import React, { useContext } from "react";

// img
import avatar from "../../images/avatar.png";

import { UserData } from "../../contexts/UserInfoContext";
import { toFarsiNumber } from "../../helper/helper";

const ThemeThree = ({ data }) => {
  const { user, loaded } = useContext(UserData);

  const circle = [1, 2, 3, 4];

  const stars = (
    <div className="flex items-center gap-1">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 24 24"
        fill="currentColor"
        class="w-5 h-5"
      >
        <path
          fill-rule="evenodd"
          d="M10.788 3.21c.448-1.077 1.976-1.077 2.424 0l2.082 5.007 5.404.433c1.164.093 1.636 1.545.749 2.305l-4.117 3.527 1.257 5.273c.271 1.136-.964 2.033-1.96 1.425L12 18.354 7.373 21.18c-.996.608-2.231-.29-1.96-1.425l1.257-5.273-4.117-3.527c-.887-.76-.415-2.212.749-2.305l5.404-.433 2.082-5.006z"
          clip-rule="evenodd"
        />
      </svg>

      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 24 24"
        fill="currentColor"
        class="w-5 h-5"
      >
        <path
          fill-rule="evenodd"
          d="M10.788 3.21c.448-1.077 1.976-1.077 2.424 0l2.082 5.007 5.404.433c1.164.093 1.636 1.545.749 2.305l-4.117 3.527 1.257 5.273c.271 1.136-.964 2.033-1.96 1.425L12 18.354 7.373 21.18c-.996.608-2.231-.29-1.96-1.425l1.257-5.273-4.117-3.527c-.887-.76-.415-2.212.749-2.305l5.404-.433 2.082-5.006z"
          clip-rule="evenodd"
        />
      </svg>

      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 24 24"
        fill="currentColor"
        class="w-5 h-5"
      >
        <path
          fill-rule="evenodd"
          d="M10.788 3.21c.448-1.077 1.976-1.077 2.424 0l2.082 5.007 5.404.433c1.164.093 1.636 1.545.749 2.305l-4.117 3.527 1.257 5.273c.271 1.136-.964 2.033-1.96 1.425L12 18.354 7.373 21.18c-.996.608-2.231-.29-1.96-1.425l1.257-5.273-4.117-3.527c-.887-.76-.415-2.212.749-2.305l5.404-.433 2.082-5.006z"
          clip-rule="evenodd"
        />
      </svg>

      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 24 24"
        fill="currentColor"
        class="w-5 h-5"
      >
        <path
          fill-rule="evenodd"
          d="M10.788 3.21c.448-1.077 1.976-1.077 2.424 0l2.082 5.007 5.404.433c1.164.093 1.636 1.545.749 2.305l-4.117 3.527 1.257 5.273c.271 1.136-.964 2.033-1.96 1.425L12 18.354 7.373 21.18c-.996.608-2.231-.29-1.96-1.425l1.257-5.273-4.117-3.527c-.887-.76-.415-2.212.749-2.305l5.404-.433 2.082-5.006z"
          clip-rule="evenodd"
        />
      </svg>
    </div>
  );

  return (
    <div className="relative flex min-w-[1024px] max-w-[1024px] m-10 h-auto border">
      {/* right side */}
      <div className="min-w-[320px] text-white flex flex-col items-center p-4 gap-5 bg-[#4c6544]">
        <div className="border-8 border-white rounded-xl p-2">
          <img
            src={
              data.user_info.avatar
                ? `https://api.myunibest.ir/${data.user_info.avatar}`
                : avatar
            }
            className="rounded-xl w-44 h-44 object-cover"
            alt=""
          />
        </div>

        <h1 className="text-2xl">
          {data.user.name + " " + data.user.family_name}
        </h1>

        <div className="w-full h-11 bg-[#3b4d35] text-[17px] flex justify-center items-center rounded-t-3xl">
          {data.job_info?.title}
        </div>

        <div className="flex flex-col items-center text-sm gap-3">
          <span>متولد : {toFarsiNumber(data.user_info?.birth)}</span>
          <span>وضعیت سربازی : {data.basic_info?.army?.name}</span>
          <span>وضیت تاهل : {data.basic_info?.in_rell?.name}</span>
          <span>{data.user_info.email}</span>
          <span>{data.user.phone_number}</span>
          <span>
            {data.user_info?.province_id?.name}, {data.user_info?.city_id?.name},{" "}
            {data.user_info.address}
          </span>
        </div>

        {/* زبان */}
        <div className="w-full flex flex-col gap-4 mt-3">
          <div className="w-full h-11 bg-[#3b4d35] text-[17px] flex justify-center items-center rounded-t-3xl">
            زبان
          </div>

          {data.langs?.length > 0
            ? data.langs?.map((lang) => (
                <div className="w-full flex items-center justify-between">
                  <span>{lang.title}</span>
                  <div className="flex items-center gap-1">
                    {circle.map((item, i) =>
                      i + 1 <= Number(lang.level.code) ? (
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          viewBox="0 0 24 24"
                          fill="currentColor"
                          class="w-5 h-5 fill-white"
                        >
                          <path
                            fill-rule="evenodd"
                            d="M10.788 3.21c.448-1.077 1.976-1.077 2.424 0l2.082 5.007 5.404.433c1.164.093 1.636 1.545.749 2.305l-4.117 3.527 1.257 5.273c.271 1.136-.964 2.033-1.96 1.425L12 18.354 7.373 21.18c-.996.608-2.231-.29-1.96-1.425l1.257-5.273-4.117-3.527c-.887-.76-.415-2.212.749-2.305l5.404-.433 2.082-5.006z"
                            clip-rule="evenodd"
                          />
                        </svg>
                      ) : (
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          viewBox="0 0 24 24"
                          fill="currentColor"
                          class="w-5 h-5 fill-white opacity-50"
                        >
                          <path
                            fill-rule="evenodd"
                            d="M10.788 3.21c.448-1.077 1.976-1.077 2.424 0l2.082 5.007 5.404.433c1.164.093 1.636 1.545.749 2.305l-4.117 3.527 1.257 5.273c.271 1.136-.964 2.033-1.96 1.425L12 18.354 7.373 21.18c-.996.608-2.231-.29-1.96-1.425l1.257-5.273-4.117-3.527c-.887-.76-.415-2.212.749-2.305l5.404-.433 2.082-5.006z"
                            clip-rule="evenodd"
                          />
                        </svg>
                      )
                    )}
                  </div>
                </div>
              ))
            : "زبان ثبت نشده است"}
        </div>

        {/* مهارت ها */}
        <div className="w-full flex flex-col gap-4 mt-5">
          <div className="w-full h-11 bg-[#3b4d35] text-[17px] flex justify-center items-center rounded-t-3xl">
            مهارت ها
          </div>

          <div className="flex flex-col gap-3">
            {data.skills?.length > 0
              ? data.skills?.map((skill) => (
                  <div className="w-full flex items-center justify-between">
                    <span>{skill.title}</span>
                    <div className="flex items-center gap-1">
                      {circle.map((item, i) =>
                        i + 1 <= Number(skill.level.code) ? (
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            viewBox="0 0 24 24"
                            fill="currentColor"
                            class="w-5 h-5 fill-white"
                          >
                            <path
                              fill-rule="evenodd"
                              d="M10.788 3.21c.448-1.077 1.976-1.077 2.424 0l2.082 5.007 5.404.433c1.164.093 1.636 1.545.749 2.305l-4.117 3.527 1.257 5.273c.271 1.136-.964 2.033-1.96 1.425L12 18.354 7.373 21.18c-.996.608-2.231-.29-1.96-1.425l1.257-5.273-4.117-3.527c-.887-.76-.415-2.212.749-2.305l5.404-.433 2.082-5.006z"
                              clip-rule="evenodd"
                            />
                          </svg>
                        ) : (
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            viewBox="0 0 24 24"
                            fill="currentColor"
                            class="w-5 h-5 fill-white opacity-50"
                          >
                            <path
                              fill-rule="evenodd"
                              d="M10.788 3.21c.448-1.077 1.976-1.077 2.424 0l2.082 5.007 5.404.433c1.164.093 1.636 1.545.749 2.305l-4.117 3.527 1.257 5.273c.271 1.136-.964 2.033-1.96 1.425L12 18.354 7.373 21.18c-.996.608-2.231-.29-1.96-1.425l1.257-5.273-4.117-3.527c-.887-.76-.415-2.212.749-2.305l5.404-.433 2.082-5.006z"
                              clip-rule="evenodd"
                            />
                          </svg>
                        )
                      )}
                    </div>
                  </div>
                ))
              : "مهارتی ثبت نشده است"}
          </div>
        </div>

        {/* شبکه های اجتماعی */}
        {/* <div className="w-full flex flex-col gap-4 mt-5">
          <div className="w-full h-11 bg-[#3b4d35] text-[17px] flex justify-center items-center rounded-t-3xl">
            شبکه های اجتماعی
          </div>

          <div className="flex flex-col gap-3">

            <div className="w-full flex items-center justify-between">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                x="0px"
                y="0px"
                className="w-10"
                viewBox="0 0 48 48"
              >
                <radialGradient
                  id="yOrnnhliCrdS2gy~4tD8ma_Xy10Jcu1L2Su_gr1"
                  cx="19.38"
                  cy="42.035"
                  r="44.899"
                  gradientUnits="userSpaceOnUse"
                >
                  <stop offset="0" stop-color="#fd5"></stop>
                  <stop offset=".328" stop-color="#ff543f"></stop>
                  <stop offset=".348" stop-color="#fc5245"></stop>
                  <stop offset=".504" stop-color="#e64771"></stop>
                  <stop offset=".643" stop-color="#d53e91"></stop>
                  <stop offset=".761" stop-color="#cc39a4"></stop>
                  <stop offset=".841" stop-color="#c837ab"></stop>
                </radialGradient>
                <path
                  fill="url(#yOrnnhliCrdS2gy~4tD8ma_Xy10Jcu1L2Su_gr1)"
                  d="M34.017,41.99l-20,0.019c-4.4,0.004-8.003-3.592-8.008-7.992l-0.019-20	c-0.004-4.4,3.592-8.003,7.992-8.008l20-0.019c4.4-0.004,8.003,3.592,8.008,7.992l0.019,20	C42.014,38.383,38.417,41.986,34.017,41.99z"
                ></path>
                <radialGradient
                  id="yOrnnhliCrdS2gy~4tD8mb_Xy10Jcu1L2Su_gr2"
                  cx="11.786"
                  cy="5.54"
                  r="29.813"
                  gradientTransform="matrix(1 0 0 .6663 0 1.849)"
                  gradientUnits="userSpaceOnUse"
                >
                  <stop offset="0" stop-color="#4168c9"></stop>
                  <stop
                    offset=".999"
                    stop-color="#4168c9"
                    stop-opacity="0"
                  ></stop>
                </radialGradient>
                <path
                  fill="url(#yOrnnhliCrdS2gy~4tD8mb_Xy10Jcu1L2Su_gr2)"
                  d="M34.017,41.99l-20,0.019c-4.4,0.004-8.003-3.592-8.008-7.992l-0.019-20	c-0.004-4.4,3.592-8.003,7.992-8.008l20-0.019c4.4-0.004,8.003,3.592,8.008,7.992l0.019,20	C42.014,38.383,38.417,41.986,34.017,41.99z"
                ></path>
                <path
                  fill="#fff"
                  d="M24,31c-3.859,0-7-3.14-7-7s3.141-7,7-7s7,3.14,7,7S27.859,31,24,31z M24,19c-2.757,0-5,2.243-5,5	s2.243,5,5,5s5-2.243,5-5S26.757,19,24,19z"
                ></path>
                <circle cx="31.5" cy="16.5" r="1.5" fill="#fff"></circle>
                <path
                  fill="#fff"
                  d="M30,37H18c-3.859,0-7-3.14-7-7V18c0-3.86,3.141-7,7-7h12c3.859,0,7,3.14,7,7v12	C37,33.86,33.859,37,30,37z M18,13c-2.757,0-5,2.243-5,5v12c0,2.757,2.243,5,5,5h12c2.757,0,5-2.243,5-5V18c0-2.757-2.243-5-5-5H18z"
                ></path>
              </svg>

              <span>shah_yad_@</span>
            </div>


            <div className="w-full flex items-center justify-between">
              <svg
                className="w-10"
                xmlns="http://www.w3.org/2000/svg"
                x="0px"
                y="0px"
                viewBox="0 0 48 48"
              >
                <path
                  fill="#29b6f6"
                  d="M24 4A20 20 0 1 0 24 44A20 20 0 1 0 24 4Z"
                ></path>
                <path
                  fill="#fff"
                  d="M33.95,15l-3.746,19.126c0,0-0.161,0.874-1.245,0.874c-0.576,0-0.873-0.274-0.873-0.274l-8.114-6.733 l-3.97-2.001l-5.095-1.355c0,0-0.907-0.262-0.907-1.012c0-0.625,0.933-0.923,0.933-0.923l21.316-8.468 c-0.001-0.001,0.651-0.235,1.126-0.234C33.667,14,34,14.125,34,14.5C34,14.75,33.95,15,33.95,15z"
                ></path>
                <path
                  fill="#b0bec5"
                  d="M23,30.505l-3.426,3.374c0,0-0.149,0.115-0.348,0.12c-0.069,0.002-0.143-0.009-0.219-0.043 l0.964-5.965L23,30.505z"
                ></path>
                <path
                  fill="#cfd8dc"
                  d="M29.897,18.196c-0.169-0.22-0.481-0.26-0.701-0.093L16,26c0,0,2.106,5.892,2.427,6.912 c0.322,1.021,0.58,1.045,0.58,1.045l0.964-5.965l9.832-9.096C30.023,18.729,30.064,18.416,29.897,18.196z"
                ></path>
              </svg>
              <span>shah_yad@</span>
            </div>
          </div>
        </div> */}
      </div>

      {/* left side */}
      <div className="w-full flex flex-col gap-8 p-4">
        <p className="text-sm text-gray-700 text-justify">{data.description}</p>

        {/* سوابق تحصیلی */}
        <div className="flex flex-col gap-4">
          <div className="w-full h-11 bg-[#4c6544] rounded-xl flex justify-center items-center p-1">
            <div className="w-56 h-full bg-gray-300 flex items-center justify-center rounded-t-[28px]">
              سوابق تحصیلی
            </div>
          </div>

          <div className="flex flex-col gap-4">
            {data.edu_info?.length > 0
              ? data.edu_info?.map((edu) => (
                  <div className="flex flex-col gap-2 text-xs">
                    <h2 className="theme-three-title relative pr-7 font-medium text-[17px]">
                      {edu.title}
                    </h2>
                    <span>مقطع تحصیلی: {edu.grade.name}</span>
                    <span>موسسه/دانشگاه: {edu.college_name}</span>
                  </div>
                ))
              : "اطلاعات تحصیلی ثبت نشده!"}
          </div>
        </div>

        {/* سوابق شغلی */}
        <div className="flex flex-col gap-4">
          <div className="w-full h-11 bg-[#4c6544] rounded-xl flex justify-center items-center p-1">
            <div className="w-56 h-full bg-gray-300 flex items-center justify-center rounded-t-[28px]">
              سوابق شغلی
            </div>
          </div>

          {data.past_jobs?.length > 0
            ? data.past_jobs?.map((job) => (
                <div className="flex flex-col gap-2 text-xs">
                  <h2 className="theme-three-title relative pr-7 font-medium text-[17px]">
                    {job.title}
                  </h2>
                  <span>نام شرکت: {job.company_name}</span>

                  <span>
                    {job.start_date
                      ? new Intl.DateTimeFormat("fa-IR", {
                          year: "numeric",
                          month: "short",
                          day: "numeric",
                        }).format(new Date(job.start_date))
                      : "ثبت نشده"}{" "}
                    -{" "}
                    {job.end_date && !job.working
                      ? new Intl.DateTimeFormat("fa-IR", {
                          year: "numeric",
                          month: "short",
                          day: "numeric",
                        }).format(new Date(job.end_date))
                      : "مشغول به کار"}
                  </span>

                  <p className="pl-3 text-sm">{job.description}</p>
                </div>
              ))
            : "سوابق شغلی ثبت نشده"}
        </div>

        {/* دوره ها و گواهینامه ها */}
        <div className="flex flex-col gap-4">
          <div className="w-full h-11 bg-[#4c6544] rounded-xl flex justify-center items-center p-1">
            <div className="w-56 h-full bg-gray-300 flex items-center justify-center rounded-t-[28px]">
              دوره ها و گواهینامه ها
            </div>
          </div>

          {data.courses?.length > 0
            ? data.courses?.map((course) => (
                <div className="flex flex-col gap-2 text-xs">
                  <h2 className="theme-three-title relative pr-7 font-medium text-[17px]">
                    {course.title}
                  </h2>
                  {/* <span>نام شرکت: {course.company_name}</span> */}

                  <span>
                    {course.start_date
                      ? new Intl.DateTimeFormat("fa-IR", {
                          year: "numeric",
                          month: "short",
                          day: "numeric",
                        }).format(new Date(course.start_date))
                      : "ثبت نشده"}{" "}
                    -{" "}
                    {course.end_date && !course.working
                      ? new Intl.DateTimeFormat("fa-IR", {
                          year: "numeric",
                          month: "short",
                          day: "numeric",
                        }).format(new Date(course.end_date))
                      : "مشغول به کار"}
                  </span>

                  <p className="pl-3 text-sm">{course.description}</p>
                </div>
              ))
            : "سوابق شغلی ثبت نشده"}
        </div>

        {/* پروژه ها */}
        <div className="flex flex-col gap-4">
          <div className="w-full h-11 bg-[#4c6544] rounded-xl flex justify-center items-center p-1">
            <div className="w-56 h-full bg-gray-300 flex items-center justify-center rounded-t-[28px]">
              پروژه ها
            </div>
          </div>

          {data.projects?.length > 0
            ? data.projects?.map((project) => (
                <div className="flex flex-col gap-2 text-xs">
                  <h2 className="theme-three-title relative pr-7 font-medium text-[17px]">{project.title}</h2>
                  <span>
                    {project.start_date
                      ? new Intl.DateTimeFormat("fa-IR", {
                          year: "numeric",
                          month: "short",
                          day: "numeric",
                        }).format(new Date(project.start_date))
                      : "ثبت نشده"}{" "}
                    -{" "}
                    {project.end_date && !project.working
                      ? new Intl.DateTimeFormat("fa-IR", {
                          year: "numeric",
                          month: "short",
                          day: "numeric",
                        }).format(new Date(project.end_date))
                      : "درحال انجام"}
                  </span>

                  <p className="text-sm">{project.description}</p>
                  <div className="flex items-center gap-2">
                    <span>لینک :</span>
                    <a
                      href={project.link}
                      target="_blank"
                      className="text-blue-600 underline"
                    >
                      {project.link}
                    </a>
                  </div>
                </div>
              ))
            : "پروژه ای ثبت نشده است"}
        </div>
      </div>
    </div>
  );
};

export default ThemeThree;
